import React, { Component } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import ReactPlayer from 'react-player'
import { isMobile } from 'react-device-detect'

import styles from './Video.module.css'

class VideoParagraph extends Component {
  state = {
    fullscreen: false,
  }

  toggleFullscreen = () => {
    if (isMobile) {
      this.setState({ fullscreen: !this.state.fullscreen })
    }
  }

  getVimeoId = url => {
    const regExp = /(videos|video|channels|\.com)\/([\d]+)/
    try {
      const id = url.match(regExp)[2]
      return id
    } catch (error) {
      return ''
    }
  }

  render() {
    const { video } = this.props
    const url = video.entity.url

    const MATCH_URL_VIMEO = /vimeo\.com\/.+/

    if (!url) {
      return null
    }

    let vimeoId = ''

    if (MATCH_URL_VIMEO.test(url)) {
      vimeoId = this.getVimeoId(url)
    }

    return (
      <div className={styles.wrapper}>
        {vimeoId ? (
          <iframe
            title={`video-${vimeoId}`}
            className={styles.player}
            src={`https://player.vimeo.com/video/${vimeoId}?title=0&byline=0&portrait=0&playsinline=1&autopause=0`}
            allowFullScreen='allowfullscreen'
            width={'100%'}
            height={'100%'}
          />
        ) : (
          <ReactPlayer
            className={styles.player}
            url={url}
            width='100%'
            height='100%'
            onPlay={this.toggleFullscreen}
            controls
          />
        )}
      </div>
    )
  }
}

VideoParagraph.propTypes = {
  video: PropTypes.shape({
    entity: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
}

const fragments = {
  paragraph: gql`
    fragment VideoParagraphFragment on ParagraphVideo {
      id
      video: fieldVideo {
        targetId
        entity {
          ... on MediaVideo {
            url: fieldMediaVideoEmbedField
          }
        }
      }
      description: fieldParagraphDescription {
        value
      }
      caption: fieldParagraphCaption {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { VideoParagraph, fragments }
